import React, { Component } from "react";
import { connect } from "react-redux";
import {
  earlyVotingWatchOn,
  earlyVotingWatchOff
} from "../../actions/earlyVotingActions";
import _ from "lodash";

import ClassCodes from "../classCodes";
import List from "./List";
import Agenda from "./Agenda";
import VotingOpen from "../debate/VotingOpen";

class EarlyVoting extends Component {
  componentDidMount() {
    this.props.earlyVotingWatchOn();
  }

  componentWillUnmount() {
    this.props.earlyVotingWatchOff();
  }

  render() {
    const { cCode } = this.props.location.params || {};
    const { users } = this.props;
    return (
      <>
        <ClassCodes />
        {cCode && !_.isEmpty(users) && (
          <>
            <Agenda />
            <List />
            <VotingOpen votingType={"earlyVoting"} />
            {/* NEED TO DEVELOP :: SHOW VISUAL RESULT */}
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  users: state.users,
  location: state.location
});

export default connect(
  mapStateToProps,
  { earlyVotingWatchOn, earlyVotingWatchOff }
)(EarlyVoting);
